import { IData, VOCategory, VOConfig } from "./DataStructure.js";
import { Resource } from "./Resource.js";

export class DataManager {
    public onComplete = e5.Signal.create();
    public onProgress = e5.Signal.create<[number]>();

    public data: IData = null;
    public config: VOConfig = null;

    private _url: string = "";

    constructor() {
    }

    public load(url: string): void {
        var xhr = new XMLHttpRequest();
        this._url = url;
        $.ajax({
            xhr: () => {

                xhr.addEventListener("progress", (evt) => {

                    var loaded = evt.loaded;
                    var total = evt.total;

                    if (!evt.lengthComputable) {
                        total = parseInt(xhr.getResponseHeader("x-decompressed-content-length"));
                    }

                    if (total === 0 || isNaN(total))
                        return;

                    this.onProgress.dispatch(loaded / total);
                }, false);
                return xhr;
            },
            cache: false,
            type: 'GET',
            url: url,
            error: (xhr) => {
                var msg = "Could not load data.";
                e5.Toast.showText(msg, 30);
            },
            success: (data) => {
                this.data = data;
                var msg = this.finalize();
                if (msg) {
                    e5.Toast.showText(msg, 30);
                } else {
                    this.onComplete.dispatch();
                }
            }
        });
    }

    private retry(): void {
        this.load(this._url);
    }

    private finalize(): string {
        if (this.data.config.length == 0) {
            return "No configs given.";
        }

        // console.log(this.data);
        // return "ERROR";

        var sortCategory = (a: VOCategory, b: VOCategory) => a.order - b.order;

        var categoryAll: VOCategory = {
            id: 0,
            label_de: "Alle",
            label_en: "All",
            order: 0,
            title: "Alle",
            kind: "all",
            videos: []
        };

        //Get global config.
        var configTitle = e5.Url.params.get("config", "Default");
        this.config = e5.array.match(this.data.config, "title", configTitle);
        if (!this.config) {
            if (configTitle != "Default") {
                this.config = e5.array.match(this.data.config, "title", "Default");
            }
            if (!this.config) {
                this.config = this.data.config[0];
            }
            console.warn(`Could not find config by title "${configTitle}". Fallback to config "${this.config.title}".`);
        }

        var videoPreviewFallbackUrl = Resource.asset("video-preview-fallback.png");
        var videoThumbnailFallbackUrl = Resource.asset("video-thumbnail-fallback.png");

        for (var video of this.data.video) {
            video.video_de = video.video_de || video.video_en;
            video.video_en = video.video_en || video.video_de;
            video.preview_image_de = video.preview_image_de || video.preview_image_en;
            video.preview_image_en = video.preview_image_en || video.preview_image_de;
            video.speaker_de = this.data.speaker.id(video.speaker_de as any);
            video.speaker_en = this.data.speaker.id(video.speaker_en as any);

            if (video.languages != "all") {
                if (video.languages != "de") {
                    video.speaker_de = null;
                    video.video_de = null;
                    video.preview_image_de = null;
                }

                if (video.languages != "en") {
                    video.speaker_en = null;
                    video.video_en = null;
                    video.preview_image_en = null;
                }
            }

            if (!video.categories) {
                video.categories = [];
            }

            if (video.use_video_snapshot_as_preview) {
                if (video.video_de
                    && video.video_de.sizes
                    && video.video_de.sizes["2048x2048"]) {
                    video.preview_de = video.video_de.sizes["2048x2048"];
                    video.thumbnail_de = video.video_de.sizes["large"];
                }

                if (video.video_en
                    && video.video_en.sizes
                    && video.video_en.sizes["2048x2048"]) {
                    video.preview_en = video.video_en.sizes["2048x2048"];
                    video.thumbnail_en = video.video_en.sizes["large"];
                }

                if (!video.preview_de) {
                    video.preview_de = video.preview_en;
                    if (!video.preview_de) {
                        video.preview_de = videoPreviewFallbackUrl;
                        video.thumbnail_de = videoThumbnailFallbackUrl;
                    }
                }

                if (!video.preview_en) {
                    video.preview_en = video.preview_de;
                    video.thumbnail_en = video.thumbnail_de;
                }

            } else {
                video.preview_de = video.preview_image_de ? video.preview_image_de.url : videoPreviewFallbackUrl;
                video.preview_en = video.preview_image_en ? video.preview_image_en.url : video.preview_de;
                video.thumbnail_de = video.preview_image_de ? video.preview_image_de.sizes["large"] : videoThumbnailFallbackUrl;
                video.thumbnail_en = video.preview_image_en ? video.preview_image_en.sizes["large"] : video.thumbnail_de;
            }

            for (var i = 0; i < video.categories.length; ++i) {
                video.categories[i] = this.data.category.id(video.categories[i] as any);
            }
            video.categories.sort(sortCategory);
        }

        for (var collection of this.data.video_collection) {
            if (collection.use_all) {
                collection.videos = this.data.video.slice();
            }
            else {
                if (!collection.videos) {
                    collection.videos = [];
                }
                for (var i = 0; i < collection.videos.length; ++i) {
                    collection.videos[i] = this.data.video.id(collection.videos[i] as any);
                }
            }
        }

        var categoryOrder = 0;
        for (var category of this.data.category) {
            category.kind = "default";
            category.videos = [];
            category.order = categoryOrder++;
        }

        for (var config of this.data.config) {
            config.videos = [];
            config.categories = [];
            if (!config.fullscreen_button_positions) {
                config.fullscreen_button_positions = [];
            }
            if (!config.show_fullscreen_buttons) {
                config.fullscreen_mode = "manual";
            }
            for (var i = 0; i < config.video_collections.length; ++i) {
                config.video_collections[i] = this.data.video_collection.id(config.video_collections[i] as any);
                if (config.video_collections[i]) {
                    for (var video of config.video_collections[i].videos) {
                        config.videos.push(video);
                        for (var category of video.categories) {
                            if (config.categories.indexOf(category) == -1) {
                                config.categories.push(category);
                            }
                        }
                    }
                }
            }
            config.categories.sort(sortCategory);
        }

        //Resolve only the videos for categories which are in use (linked by the config).
        this.config.categories.unshift(categoryAll);
        for (var collection of this.config.video_collections) {
            for (var video of collection.videos) {
                // categoryAll.videos.push(video);
                video.categories.unshift(categoryAll);
                for (var category of video.categories) {
                    category.videos.push(video);
                }
            }
        }

        return null;
    }
}